import React from "react";
import RouteWrapper from "./RouteWrapper";
import Schedule from "./components/Schedule";
import Kiosk from "./components/Kiosk";
import KioskSessionAuditions from "./components/Kiosk/AuditionList/KioskSessionAuditions";
import KioskManagement from "./components/Kiosk/Admin/KioskManagement";
import TemplateInfoSheet from "./components/Kiosk/InfoSheet/Template/TemplateInfoSheet";
import AuditionInfoSheet from "./components/Kiosk/InfoSheet/Audition/AuditionInfoSheet";
import Directions from "./components/Kiosk/Directions";
import ActorVideoDirection from "./components/ActorVideoDirection";

const Routes = (): any[] => {
  const isProd =
    process.env.REACT_APP_API === "production" ||
    process.env.REACT_APP_API === "staging";

  const baseName =
    process.env && isProd
      ? process.env.PUBLIC_URL
      : process.env.REACT_APP_BaseName;

  const isKiosk = baseName.indexOf("kiosk") > -1;

  return isKiosk ?
    [
      (<RouteWrapper
        exact
        requireAuth
        path="/"
        // @ts-ignore
        render={(routeProps) => <Kiosk {...routeProps} />}
      />),
      (<RouteWrapper
        path="/actor/vd/:token"
        // @ts-ignore
        render={(routeProps) => <ActorVideoDirection {...routeProps} />}
      />),
      (<RouteWrapper
        path="/actor/vd"
        // @ts-ignore
        render={(routeProps) => <ActorVideoDirection {...routeProps} />}
      />),
      (<RouteWrapper
        requireAuth
        path="/vcr/:scheduleId?/:created?"
        // @ts-ignore
        render={(routeProps) => <Kiosk {...routeProps} />}
      />),
      (<RouteWrapper
        requireAuth
        path="/sessionAuditions/:id"
        // @ts-ignore
        render={(routeProps) => <KioskSessionAuditions {...routeProps} />}
      />),
      (<RouteWrapper
        requireAuth
        path="/templateInfoSheet/:id"
        // @ts-ignore
        render={(routeProps) => <TemplateInfoSheet {...routeProps} />}
      />),
      (<RouteWrapper
        requireAuth
        path="/direction/:scheduleId"
        // @ts-ignore
        render={(routeProps) => <Directions />}
      />),
      (<RouteWrapper
        requireAuth
        path="/auditionInfoSheet/:scheduleId/:infoSheetId/:auditionScheduleId"
        // @ts-ignore
        render={(routeProps) => <AuditionInfoSheet {...routeProps} />}
      />),
      (<RouteWrapper
        requireAuth
        path="/kioskManagement"
        component={KioskManagement}
      />)
    ]
    :
    [
      (<RouteWrapper
        exact
        path="/"
        // @ts-ignore
        render={(routeProps) => <Schedule {...routeProps} />}
      />)
    ]
};

export default Routes;
